import { render } from "./HeaderComp.vue?vue&type=template&id=7b480b7e&scoped=true"
import script from "./HeaderComp.vue?vue&type=script&lang=js"
export * from "./HeaderComp.vue?vue&type=script&lang=js"

import "./HeaderComp.vue?vue&type=style&index=0&id=7b480b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b480b7e"]])

export default __exports__